/* global angular */
angular.module('bzPotentialLeadFormModule', ['ngMask'])
